<script>
    export default {
        name: '',
        props: {
            feedback: {
                required: false,
                default: '',
                type: String
            },
            feedbackAt: {
                required: false,
            }
        },
        data () {
            return {};
        },
        methods: {},
        components: {},
        mounted () {
        }
    };
</script>

<template>
    <div class="feedback" v-if="feedback">
        <div class="feedback-title">
            结果反馈 <span class="feedback-time" v-if="feedbackAt">反馈时间：{{feedbackAt}}</span>
        </div>
        <div class="feedback-content" v-html="feedback">
        </div>
    </div>
</template>

<style lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .feedback {
        .px2rem(font-size, 28);
        .px2rem(margin-bottom, 90);
        .px2rem(margin-top, 90);

        &-title {
            font-weight: bold;
            color: @otherNormalTitleClr;
            .px2rem(margin-bottom, 22);
            .px2rem(padding-bottom, 34);
            border-bottom: 1px solid @otherGreyBgClr;
        }

        &-time {
            font-weight: normal;
            color: @otherBtnBorderNoteClr;
            .px2rem(margin-left, 30);
        }

        &-content {
            color: #000;

        }

        &-list {
            .normal-cell {
                padding-left: 0;
                padding-right: 0;
            }
        }
    }
</style>
